export default class AccountSettings {
    static fromData(data) {
        if (!data) {
            return;
        }

        const accountSettings = new AccountSettings();
        accountSettings.id = data.id;
        accountSettings.notifyEvents = data.notifyEvents;
        accountSettings.notifyTasks = data.notifyTasks;
        accountSettings.notifyNews = data.notifyNews;
        accountSettings.notifyFiles = data.notifyFiles;
        accountSettings.notifyOfferings = data.notifyOfferings;

        accountSettings.gender = data.gender;
        accountSettings.hasAvatar = data.hasAvatar;
        accountSettings.fullName = data.fullname;
        accountSettings.signature = data.signature;

        return accountSettings;
    }
}
